<template>
<a href="javascript:void(0);" class="comments_load_more" @click="$emit('load-more')">瞧瞧全部留言</a>
</template>

<script>
    export default {
        emits: ['load-more']
    }
</script>